import styled from "styled-components"

const StyledImageWrapper = styled.div`
  margin-top: 1.6rem;
  display: flex;
  justify-content: center;
`

export { StyledImageWrapper }
